<template>
  <div class="progress">
    <div :class="`progress__bar${isHidden ? ' progress__bar--hidden' : '' }`">
      <div class="progress__bar__amount" :style="`width: ${progress == 0 ? 1 : progress}%`"></div>
      <div class="progress__bar__details" v-if="!isHidden">
        {{ $t('progressBar.percentageComplete', { progress }) }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'progress-bar',
    data() {
      return {
        progress: this.$store.getters.envelopeProgress(),
        isHidden: false,
      };
    },
    created() {
      this.$bus.$on('addedNewDoneField', () => {
        this.progress = this.$store.getters.envelopeProgress();
      });
      this.$bus.$on('scrollingDown', () => {
        this.isHidden = true;
      });
      this.$bus.$on('scrollingUp', () => {
        this.isHidden = false;
      });
    },
  };
</script>

<style lang="sass" scoped>
  @import '~styles/component-utils.sass';
  $spacing-progress-bar: $spacing-base + 5;
  $progress-bg: $signable-secondary-1;
  .progress
    text-align: center;
    &__bar
      position: fixed;
      background-color: rgba(255, 255, 255, 0.5);
      padding: $spacing-progress-bar;
      margin: (-$spacing-large) (-$spacing-large) $spacing-large;
      top: 76px;
      width: 75%;
      z-index: 99;
      transition: all .1s ease-in-out;
      &__amount
        position: absolute;
        padding: $spacing-progress-bar 0;
        background-color: $progress-bg;
        transition: width .25s ease-in-out;
        top: 0;
        left: 0;
      &__details
        position: absolute;
        left: 50%;
        top: 61px;
        transform: translate3d(-50%, -50%, 0);
        padding: $spacing-xs $spacing-small;
        background: #000;
        text-transform: uppercase;
        border-radius: $spacing-xs;
        font-size: 11px;
        font-weight: bold;
        color: #fff;
  // Responsive
  @media screen and (max-width: $screen-size-large)
    .progress
      &__bar
        width: 100%;
        top: 91px;
        margin: -34px (-$spacing-large) $spacing-large;
        &--hidden
          top: 38px;
  @media screen and (max-width: $screen-size-medium)
    .progress
      &__bar
        margin: 0 0 $spacing-large;
        top: 60px;
        &--hidden
          top: 4px;
</style>



// WEBPACK FOOTER //
// ProgressBar.vue?2834da44